import { ACCOUNT_ID, DIMENSION } from 'hooks';
import { CAMPAIGNS_ROUTE, ENTITY } from 'modules/campaigns/config/routes';
import { REPORT_ENTITY_IDS } from 'modules/campaigns/hooks/useReportEntityIds';
import { REPORT_ENTITY_TYPE } from 'modules/campaigns/hooks/useReportEntityType';
import {
    ActionableTextWithInternalLinkCellRenderer,
    FormattedMessageHeaderRenderer,
    FormattedMessageWithTooltipHeaderRenderer,
    formattedNumberValueGetter,
    gridNumberFormatter,
} from 'modules/campaigns/modules/campaigns-reports/components';
import { keyColumn, leftPinnedColumn, numericColumn } from 'modules/campaigns/modules/campaigns-reports/config/columns';
import { nonDefaultHeaderComponentParams } from 'modules/campaigns/modules/campaigns-reports/config/fields';
import { DATE_PRESET, END_DATE, REPORT_ID, START_DATE } from 'modules/campaigns/modules/campaigns-reports/hooks';
import { normalizeColumnDefs } from 'modules/campaigns/modules/campaigns-reports/utils';
import * as FIELDS from '../../fields';
import { CREATIVE_REPORT_ID } from '../creative/creativeReportId';
import { HIERARCHY_CAMPAIGN_REPORT_ID } from './hierarchyCampaignReportId';

const hierarchyCampaignReportColumnDefinition = [
    {
        field: FIELDS.ID.field,
        headerName: FIELDS.ID.label,
        headerComponentParams: nonDefaultHeaderComponentParams(HIERARCHY_CAMPAIGN_REPORT_ID),
        type: [numericColumn],
        headerValueGetter: FormattedMessageHeaderRenderer,
    },
    {
        field: FIELDS.NAME.field,
        headerName: FIELDS.NAME.label,
        headerComponentParams: nonDefaultHeaderComponentParams(HIERARCHY_CAMPAIGN_REPORT_ID),
        type: [leftPinnedColumn, keyColumn],
        headerValueGetter: FormattedMessageHeaderRenderer,
        editable: false,
        cellRenderer: ActionableTextWithInternalLinkCellRenderer,
        cellRendererParams: {
            lines: 2,
            to: CAMPAIGNS_ROUTE,
            paramsToKeep: [ACCOUNT_ID, DIMENSION, START_DATE, END_DATE, DATE_PRESET],
            paramsFactory: ({ id }) => ({
                [REPORT_ENTITY_IDS]: id,
                [REPORT_ENTITY_TYPE]: ENTITY.CAMPAIGN,
                [REPORT_ID]: CREATIVE_REPORT_ID,
            }),
            isSearchable: true,
        },
    },
    ...[
        FIELDS.PROFIT_MARGIN,
        FIELDS.ESTIMATED_BILLABLE_AMOUNT,
        FIELDS.CLICKS,
        FIELDS.IMPRESSIONS,
        FIELDS.VISIBLE_IMPRESSIONS,
        FIELDS.SPENT,
        FIELDS.CONVERSIONS,
        FIELDS.CONVERSIONS_CLICKS,
        FIELDS.CONVERSIONS_VIEWS,
        FIELDS.CONVERSIONS_VALUE,
        FIELDS.VCPM,
        FIELDS.VCTR,
        FIELDS.AVERAGE_CPC,
        FIELDS.CPA,
        FIELDS.CPA_CLICKS,
        FIELDS.CPA_VIEWS,
        FIELDS.CVR,
        FIELDS.CVR_CLICKS,
        FIELDS.CVR_VIEWS,
        FIELDS.ROAS,
    ].map(fieldConfig => ({
        headerName: fieldConfig.label,
        headerValueGetter: fieldConfig.headerValueGetter || FormattedMessageWithTooltipHeaderRenderer,
        headerComponentParams: fieldConfig.headerComponentParams,
        field: fieldConfig.field,
        type: [numericColumn],
        cellRenderer: fieldConfig.cellRenderer,
        valueFormatter: !fieldConfig.cellRenderer && gridNumberFormatter,
        cellRendererParams: fieldConfig.renderParams,
        csvValueGetter: fieldConfig.csvValueGetter || formattedNumberValueGetter,
        referenceColId: fieldConfig.referenceColId,
        accountConfigurations: fieldConfig.accountConfigurations,
        permissions: fieldConfig.permissions,
        visibilityCondition: fieldConfig.visibilityCondition,
    })),
];

export default normalizeColumnDefs(hierarchyCampaignReportColumnDefinition, HIERARCHY_CAMPAIGN_REPORT_ID);
